import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
export default (function (_ref) {
  var service = _ref.service,
      request = _ref.request,
      serviceForMock = _ref.serviceForMock,
      requestForMock = _ref.requestForMock,
      mock = _ref.mock,
      faker = _ref.faker,
      tools = _ref.tools;
  return {
    /**
     * @description 地址列表
     */
    addressList: function addressList() {
      var _arguments = arguments;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                data = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : {};
                return _context.abrupt("return", request({
                  url: '/delivery/addressList',
                  data: data
                }));

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },

    /**
     * @description 保存地址
     */
    saveAddress: function saveAddress() {
      var _arguments2 = arguments;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                data = _arguments2.length > 0 && _arguments2[0] !== undefined ? _arguments2[0] : {};
                return _context2.abrupt("return", request({
                  url: '/delivery/saveAddress',
                  data: data
                }));

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },

    /**
     * @description 删除地址
     */
    deleteAddress: function deleteAddress() {
      var _arguments3 = arguments;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var data;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                data = _arguments3.length > 0 && _arguments3[0] !== undefined ? _arguments3[0] : {};
                return _context3.abrupt("return", request({
                  url: '/delivery/deleteAddress',
                  data: data
                }));

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },

    /**
     * @description 地址详情
     */
    addressDetails: function addressDetails() {
      var _arguments4 = arguments;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var data;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                data = _arguments4.length > 0 && _arguments4[0] !== undefined ? _arguments4[0] : {};
                return _context4.abrupt("return", request({
                  url: '/delivery/addressDetails',
                  data: data
                }));

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },

    /**
     * @description 运费模板列表
     */
    deliveryFees: function deliveryFees() {
      var _arguments5 = arguments;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var data;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                data = _arguments5.length > 0 && _arguments5[0] !== undefined ? _arguments5[0] : {};
                return _context5.abrupt("return", request({
                  url: '/delivery/deliveryFees',
                  data: data
                }));

              case 2:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },

    /**
     * @description 保存运费模板
     */
    saveDeliveryFee: function saveDeliveryFee() {
      var _arguments6 = arguments;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var data;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                data = _arguments6.length > 0 && _arguments6[0] !== undefined ? _arguments6[0] : {};
                return _context6.abrupt("return", request({
                  url: '/delivery/saveDeliveryFee',
                  data: data
                }));

              case 2:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    },

    /**
     * @description 删除运费模板
     */
    deleteDeliveryFee: function deleteDeliveryFee() {
      var _arguments7 = arguments;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var data;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                data = _arguments7.length > 0 && _arguments7[0] !== undefined ? _arguments7[0] : {};
                return _context7.abrupt("return", request({
                  url: '/delivery/deleteDeliveryFee',
                  data: data
                }));

              case 2:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }))();
    },

    /**
     * @description 运费模板详情
     */
    deliveryFeeDetails: function deliveryFeeDetails() {
      var _arguments8 = arguments;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var data;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                data = _arguments8.length > 0 && _arguments8[0] !== undefined ? _arguments8[0] : {};
                return _context8.abrupt("return", request({
                  url: '/delivery/deliveryFeeDetails',
                  data: data
                }));

              case 2:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }))();
    },

    /**
     * @description 配送区域
     */
    getDeliveryArea: function getDeliveryArea() {
      var _arguments9 = arguments;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var data;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                data = _arguments9.length > 0 && _arguments9[0] !== undefined ? _arguments9[0] : {};
                return _context9.abrupt("return", request({
                  url: '/delivery/getDeliveryArea',
                  data: data
                }));

              case 2:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }))();
    },

    /**
     * @description 保存配送区域设置
     */
    saveDeliveryArea: function saveDeliveryArea() {
      var _arguments10 = arguments;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        var data;
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                data = _arguments10.length > 0 && _arguments10[0] !== undefined ? _arguments10[0] : {};
                return _context10.abrupt("return", request({
                  url: '/delivery/saveDeliveryArea',
                  data: data
                }));

              case 2:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }))();
    }
  };
});